import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private spinnerCountSubject = new BehaviorSubject<number>(0);
  spinnerCount$ = this.spinnerCountSubject.asObservable();

  show(): void {
    this.spinnerCountSubject.next(this.spinnerCountSubject.value + 1);
 

  }

  hide(): void {
    const currentCount = this.spinnerCountSubject.value;
    if (currentCount > 0) {
      this.spinnerCountSubject.next(currentCount - 1);
    }
  }

  getCountSpinner() : number
  {
    return this.spinnerCountSubject.value;
  }
}